module.exports = __webpack_public_path__ + "static/img/it_icon2.572509a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/it_icon2.png
// module id = IlMU
// module chunks = 0